__turbopack_context__.v({
  "container": "styles-module__HgKp1W__container",
  "image": "styles-module__HgKp1W__image",
  "imagePlaceholder": "styles-module__HgKp1W__imagePlaceholder",
  "ratingContainer": "styles-module__HgKp1W__ratingContainer",
  "username": "styles-module__HgKp1W__username",
});
